export function normalizeBrokenHtml(text: string): string {
  if (!text) return "";

  return text
    .replace(/artId=[^'">\s]+['"]?>/gi, "")
    .replace(/href=['"][^'"]*$/gi, "")
    .replace(/<[^>]*$/g, "")
    .trim();
}
